<template>
  <v-card max-width="344" class="mx-auto">
    <v-list-item :disabled="false">
      <v-list-item-avatar color="grey">
        <v-img :src="getImageSrc(item.main_image)" max-height="50"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-img :src="getImageSrc(item.banner)" max-height="120"></v-img>

    <v-card-text>
      <div>
        {{ item.description | truncate(70) }}
      </div>
      <div class="d-flex align-center" v-if="ShowActions">
        <toggle-service
          :is-edit="true"
          model-name="supporter"
          :model-id="item.id"
          field="visible"
          v-model="item.visible"
          :validate="true"
          class="mt-0"
        />
        <v-chip class="ma-2 mt-4" small>
          {{ $t("table.visibility") }}
        </v-chip>
      </div>
    </v-card-text>

    <v-card-actions v-if="ShowActions">
      <v-btn
        text
        color="deep-purple accent-4"
        :to="{ name: 'editSupporter', params: { slug: item.slug } }"
      >
        {{ $t("button.edit") }}
      </v-btn>
      <v-btn text color="red lighten-2" @click="handleDelete">
        {{ $t("button.delete") }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { deleteSupporter } from "@/api/supporter";
export default {
  name: "SupporterCard",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    ShowActions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visibleText() {
      return this.item.visible
        ? this.$t("table.visible")
        : this.$t("table.invisible");
    }
  },
  data() {
    return {};
  },
  methods: {
    getImageSrc(item) {
      if (item === null || item === undefined) {
        return "https://cdn.vuetifyjs.com/images/cards/mountain.jpg";
      } else {
        return item.path;
      }
    },
    handleDelete() {
      this.popUp().then(value => {
        if (!value.dismiss) {
          deleteSupporter(this.item.slug)
            .then(() => {
              this.$emit("deleted", this.index);
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
